export function prependNumber(prependedNumber: string, value: string) {
  if (value === null || value === undefined) return false
  return prependedNumber.substring(value.length) + value
}
